import { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './ProfileMenu.css';
import config from '../config';
import { LogoutConfirmDialog } from './LogoutConfirmDialog';

export const ProfileMenu = ({ user, onLogout, campaignActive = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !event.target.closest('.lcd-dialog') &&
        !event.target.closest('.lcd-overlay')
      ) {
        setIsOpen(false);
        setShowDialog(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="profile-menu" ref={menuRef}>
      <button 
        className="avatar-button"
        onClick={() => {
        setShowDialog(false); // ensure dialog closed when avatar clicked
        setIsOpen(!isOpen);
      }}
      >
        {user?.picture ? (
          <img 
            src={user.picture} 
            alt={user.name || 'Profile'} 
            className="avatar-image"
          />
        ) : (
          <div className="avatar-placeholder">
            {user?.name?.charAt(0) || 'U'}
          </div>
        )}
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="dropdown-menu"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.1 }}
          >
            <a
              href="https://discord.gg/dDTem2P"
              target="_blank"
              rel="noopener noreferrer"
              className="logout-button"
              style={{ textDecoration: 'none' }}
            >
              Join Discord
            </a>
            <button
              onClick={() => {
                setIsOpen(false);
                if (campaignActive) {
                  setShowDialog(true);
                } else {
                  onLogout();
                }
              }}
              className="logout-button"
            >
              Logout
            </button>

          </motion.div>
        )}
      </AnimatePresence>
      {/* Logout confirmation dialog rendered here so it stays mounted even when dropdown is closed */}
      <LogoutConfirmDialog
        open={showDialog}
        onLogout={onLogout}
        onRunInSpirit={onLogout}
        closeDialog={() => setShowDialog(false)}
        onPause={async () => {
          window.dispatchEvent(new CustomEvent('pauseTest', {detail: Date.now()}));
          try {
            const token = localStorage.getItem(config.tokenKey);
            const res = await fetch(`${config.apiUrl}/api/sessions/pause_all`, {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {})
              }
            });
          if (!res.ok) {
            const text = await res.text();
            throw new Error(text || `Pause failed: ${res.status}`);
          }
          } catch (err) {
            console.error('Failed to pause campaigns:', err);
            // Surface error to dialog
            throw err;
          }
        }}
        onCancel={() => setShowDialog(false)} />
    </div>
  );
};